
import { gql } from 'shared/types/layoutcreator'

export const GET_COVER_TEMPLATE_CATEGORIES = gql(/* GraphQL */ `
  query getCoverTemplateCategories {
    getCoverTemplateCategories
  }
`)

export const GET_COVER_TEMPLATES = gql(/* GraphQL */ `
  query getCoverTemplates {
    getCoverTemplates {
      id
      name
      path
      previewUrl
      category
    }
  }
`)
 
export const CHECK_FOR_CUSTOM_COVER = gql(/* GraphQL */ `
  query checkForCustomCover($projectId: String!) {
    checkForCustomCover(projectId: $projectId) {
      inside
      outside
    }
  }
`)
